import { CSSProperties } from "react";

export enum variant {
  outlined = "outlined",
  filled = "filled",
  normal = "standard",
}

export enum margin {
  normal = "normal",
  dense = "dense",
}

export enum size {
  small = "small",
  medium = "medium",
}
export interface InputParameters<T = any> {
  id?: string;
  label?: React.ReactNode;
  name?: string;
  placeholder?: string;
  className?: string;
  value?: T;
  defaultValue?: any;
  sufix?: React.ReactNode;
  prefix?: React.ReactNode;
  autofocus?: boolean;
  disabled?: boolean;
  error?: boolean;
  readonly?: boolean;
  fullWidth?: boolean;
  multiline?: boolean;
  maxLength?: number;
  maxRows?: number;
  minRows?: number;
  margin?: "normal" | "dense" | "none";
  size?: "small" | "medium";
  variant?: "outlined" | "filled" | "standard";
  helperText?: React.ReactNode;
  onKeyPress?: Function;
  onClick?: Function;
  onKeyUp?: Function;
  onKeyDown?: Function;
  onBlur?: Function;
  onFocus?: Function;
  onChange?: Function;
  type?: "text" | "date" | "time" | "datetime-local" | "password" | "number" | "tel";
  InputLabelProps?: any;
  inputProps?: any;
  InputProps?: any;
  ref?: any;
  inputRef?: any;
  style?: CSSProperties;
}

export type ChangeValue = {
  value: any;
  numberValue?: number;
  name: string | null;
}
export interface CustomTextField {
  onChangeValue?: (newValue: ChangeValue) => void
}
